import { VenueFillRate } from '../VenueFillRate';

export class VenueFillRatePartner extends VenueFillRate {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}



// WEBPACK FOOTER //
// ./src/screens/admin/partners/VenueFillRatePartner.js